import React, { useState, useEffect } from "react";
import Turnstile from "react-turnstile";
import { properties, isValidEmail } from "../common/properties";
import { createForgotPasswordAPIBody, fetchForgotPasswordAPI } from "../utils";
import SuccessMessage from "./SuccessMessage";

interface ForgotPasswordProps {
  locale: string;
  targetUrl: any;
  resetTargetUrl: string | null;
  siteKey?: string;
}

const ForgotPasswordForm: React.FC<ForgotPasswordProps> = (
  props: ForgotPasswordProps
) => {
  const { locale, targetUrl, resetTargetUrl, siteKey } = props;
  let payload: forgotPasswordPayload;
  const [email, setEmail] = useState<string>("");
  const [isPasswordReset, setIsPasswordReset] = useState<boolean>(false);
  const [captchaToken, setcaptchaToken] = useState<any>(false);
  const [captchaTokenMobile, setcaptchaTokenMobile] = useState<any>(false);
  const [emailValidationStatus, setEmailValidationStatus] =
    useState<boolean>(false);
  const [errorStatus, setErrorStatus] = useState<boolean>(false);
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setEmailValidationStatus(isValidEmail(e.target.value));
  };
  const resetStatesBeforeAPICall = () => {
    setEmail("");
    setIsPasswordReset(true);
    setcaptchaToken(false);
    setcaptchaTokenMobile(false);
    setEmailValidationStatus(false);
  };
  const handleSignInBtnClick = () => {
    const redirectUrl = resetTargetUrl || targetUrl;
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = `/${locale}/login`;
    }
  };
  const handleResetPassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    emailValidationStatus && errorStatus && setErrorStatus(false);
    !emailValidationStatus && setErrorStatus(true);
    if (emailValidationStatus && window.innerWidth > 640 && captchaToken) {
      resetStatesBeforeAPICall();
      payload = createForgotPasswordAPIBody(
        email,
        captchaToken,
        properties.baseURL,
        targetUrl,
        locale
      );
      await fetchForgotPasswordAPI(payload);
    }

    if (
      emailValidationStatus &&
      window.innerWidth < 641 &&
      captchaTokenMobile
    ) {
      resetStatesBeforeAPICall();
      payload = createForgotPasswordAPIBody(
        email,
        captchaTokenMobile,
        properties.baseURL,
        targetUrl,
        locale
      );
      await fetchForgotPasswordAPI(payload);
    }
  };

  return (
    <div className="wiley-forgotPasswordMainDiv">
      {isPasswordReset ? (
        <>
          <SuccessMessage message={properties.forgotPasswordSuccessMessage} />
          <div className="wileySignInAndResendBtns">
            <button onClick={handleSignInBtnClick} id="wiley-signInBtn">
              <span className="wileyCommonBtnText"> Continue to sign in</span>
            </button>
            <button
              onClick={() => setIsPasswordReset(false)}
              id="wiley-resendPasswordResetBtn"
            >
              <span className="wileyCommonBtnText">
                {" "}
                Resend password reset link
              </span>
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="wiley-forgotPasswordHeader">
            <h1 className="wiley-forgotPasswordHeading">Forgot Password</h1>
            <h2 className="wiley-forgotPasswordSubHeading">
              Enter the email address you used to create your Wiley account. We
              will locate your account information and send you an email with a
              link to reset your password.
            </h2>
          </div>
          <form
            id="forgottenPwdForm"
            onSubmit={async (e: any) => {
              await handleResetPassword(e);
            }}
          >
            <div className="form-field">
              <label className="formFieldLabel">Email Address</label>
              <input
                type="text"
                placeholder="Email Address"
                value={email}
                onChange={handleEmailChange}
                className={errorStatus ? "validationError" : "valid"}
              />
              <div
                className={errorStatus ? "error show" : "error"}
                role="alert"
              >
                {properties.invalid_email_msg}
              </div>
            </div>
            {!isPasswordReset && (
              <div className="captcha">
                <div className="captchVerfication">
                  <div className="captchaHeader">
                    {captchaToken
                      ? "Verifying you are a human."
                      : "Please Verify that you are a human."}
                  </div>
                  <Turnstile
                    sitekey={siteKey ?? ""}
                    onVerify={(token) => {
                      setcaptchaToken(token);
                    }}
                  />
                </div>
                <div className="captchVerficationMobile">
                  <div className="captchaHeader">
                    {captchaTokenMobile
                      ? "Verifying you are a human."
                      : "Please Verify that you are a human."}
                  </div>
                  <Turnstile
                    sitekey={siteKey ?? ""}
                    size="compact"
                    onVerify={(token) => {
                      setcaptchaTokenMobile(token);
                    }}
                  />
                </div>
              </div>
            )}
            <button type="submit" id="wiley-forgotPasswordSubmitBtn">
              <span className="wileyCommonBtnText"> Reset Password</span>
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
